<template>
  <div class="page endpayment" v-if="paymentRunning && callCycleCounter <= maxCounter">
    <header>&nbsp;</header>
    <div v-if="isMobile || true" class="noheader">
      <!-- <div class="flexcentered bigger" v-if="paymentRunning && callCycleCounter <= maxCounter">
        {{ 'PaymentChecking' | lang }}<br />
        Tentativo {{callCycleCounter}}
      </div> -->
      <div class="flexcentered bigger">
        <div><i class="fa fa-fw fa-refresh fa-spin"></i></div>
      </div>
    </div>
    <footer style="justify-content: center">{{ 'PaymentChecking' | lang }}</footer>
  </div>
  <div class="page endpayment" v-else>
    <header>&nbsp;</header>
    <div v-if="isMobile || true">
      <div class="flexcentered bigger status">
        <i class="fa fa-fw" :class="iconClass"></i>
        <div v-if="status === 'paymentaccepted'">{{ 'PaymentIsOk' | lang }}</div>
        <div v-else-if="status === 'paymentdenied'">{{ 'PaymentIsKo' | lang }}</div>
        <div v-else-if="status === 'vadcommunicationproblem'">{{ 'PaymentIsKoVAD' | lang }}</div>
        <div v-else-if="status === 'paymentinprogress'">{{ 'PaymentIsUnknown' | lang }}</div> <!-- ¯\_(ツ)_/¯ -->
        <div v-else>Errore sconosciuto</div>
      </div>
    </div>
    <footer class="flexrow">
      <button @click="goTo('/mytickets')" v-if="wasEticketCart">{{ 'MyTickets' | lang }}</button>
      <button @click="goTo('/', true)">{{ 'BackToHomepage' | lang }}</button>
    </footer>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
// import { create } from 'vue-modal-dialogs'
// import CartPaymentEndDialog from '@/dialogs/CartPaymentEndDialog'
import databaseWrapperMixin from '@/mixins/databaseWrapperMixin'
import paymentServices from '@/mixins/services/paymentServices'

// const cartPaymentEndDialogCreator = create(CartPaymentEndDialog)
// 0 in corso
// 1 accettato
// 2 negato

export default {
  name: 'EndPaymentPage',
  mixins: [ page, databaseWrapperMixin, paymentServices ],
  data () {
    return {
      callCycleCounter: 0,
      maxCounter: 15,
      status: null,
      wasEticketCart: false
    }
  },
  computed: {
    iconClass () {
      if (this.status === 'paymentinprogress') return 'fa-question-circle-o'
      if (this.status === 'paymentaccepted') return 'fa-check-circle-o'
      if (this.status === 'paymentdenied') return 'fa-times-circle-o'
      if (this.status === 'vadcommunicationproblem') return 'fa-times-circle-o'
      return ''
    }
  },
  methods: {
    close () {
      window.close()
    },
    callCycle () {
      /* if (!this.user) {
        console.warn('no user')
        this.callCycleTimeout = setTimeout(this.callCycle, 500)
        return
      }
      console.warn('Yes user') */
      this.callCycleCounter = this.callCycleCounter ? this.callCycleCounter + 1 : 1
      if (this.callCycleCounter > this.maxCounter) {
        this.paymentDone(undefined)
        return
      }
      this._checkPaymentStatus(this.paymentRunning.code, this.paymentRunning.orderId, this.paymentRunning.usertoken).then(response => {
        console.log("_checkPaymentStatus response", response)
        let status = response.PaymentStatus ? response.PaymentStatus.toLowerCase() : response.PaymentStatus
        console.log("_checkPaymentStatus status", status)
        this.status = status
        this.wasEticketCart = false
        if (status === 'paymentaccepted') { // successful
          this.manageTickets(response)
          this.paymentDone(true)
        } else if (status === 'paymentdenied') { // failed
          this.paymentDone(false)
        } else if (status === 'vadcommunicationproblem') { // vad unavailable
          this.paymentDone(false)
        } else if (status === 'paymentinprogress') { // boh, retry immediately
          this.callCycleTimeout = setTimeout(this.callCycle, Math.min(1000 + (this.callCycleCounter * 1000), 10000))
        } else { // unexpected!
          console.warn(`Unexpected value ${status} from checkOrderStatus!`)
          this.paymentDone(false)
        }
        this.incall = false
      }).catch(err => {
        console.warn(err)
        // this.paymentDone(false)
        if (this.callCycleCounter < 5) {
          this.callCycleTimeout = setTimeout(this.callCycle, 300)
        } else {
          this.status = 'paymentinprogress'
          this.paymentDone(false)
        }
      })
    },
    manageTickets (response) {
      if (response.Etickets && response.Etickets.length) {
        this.wasEticketCart = true
        response.Etickets.forEach(doc => {
          // this.showBase64(doc)
          this.dwSaveNewTicket(doc)
        })
      }
    },
    paymentDone (/* success */) {
      this.paymentRunning = null
      this.internalBus.$emit('updateCart')
      /* cartPaymentEndDialogCreator({ success }).then(() => {
        console.log('success', success)
        if (success) {
          // this.dwCloseCart(true)
          this.goTo(this.isEticketCart ? '/mytickets' : '/', true)
        }
      }) */
    },
    showBase64 (doc) {
      if (!doc) {
        alert('No doc')
      } else {
        /* let link = document.createElement('a')
        link.href = doc.File
        link.click() */
        // window.open('data:application/pdf;base64,' + (doc.File || doc.file), '_blank')
        let win = window.open()
        win.document.write('<iframe src="' + 'data:application/pdf;base64,' + doc.qrcode  + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe><style>html, body, iframe { margin: 0; padding:0; }</style>');
        // doc.DocumentReference è il nome del file pdf
      }
    }
  },
  mounted () {
    /* this.paymentRunning = null
    this.goTo('/')
    return */
    console.log('endpayment mounted', this.paymentRunning)
    // this.paymentRunning = null
    if (this.paymentRunning) {
      if (this.paymentRunning.free) {
        this.status = 'paymentinprogress'
        this._closeFreeCart(this.cart2.OrderId).then(response => {
          // console.log(response)
          this.manageTickets(response)
          this.paymentDone(true)
          this.status = 'paymentaccepted'
        }).catch(err => {
          console.error(err)
        })
      } else {
        if (this.paymentRunning.methodToken) {
          localStorage.setItem('lastPaymentToken', this.paymentRunning.methodToken)
        }
        this.callCycle()
      }
    } else {
      // alert('Pagamento non in corso, che faccio? Recupero i biglietti?')
      console.log('no payment running')
      this.goTo('/', true)
      // this.wasEticketCart = true
      // this.status = 'paymentaccepted'
      // this.paymentRunning = {}
    }
  },
  beforeDestroy () {
    clearTimeout(this.callCycle)
  }
}
</script>

<style lang="scss">
// @import '@/assets/_vars.scss';

.endpayment .status {
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;

  i {
    font-size: 10rem;
  }

  div {
    max-width: 18rem;
  }

  .fa-check-circle-o {
    color: var(--green);
  }

  .fa-times-circle-o {
    color: var(--red);
  }

  .fa-question-circle-o {
    color: var(--orange);
  }
}

</style>
